import styled from 'styled-components'

export const PaypalButtonContainer = styled.div`
  width: 275px !important;
  opacity: 0;
  @media (max-width: 576px) {
    width: 75% !important;
  }
`
